<template>
  <v-container fluid class="py-0" :style="'height:' + computedPageHeight + 'px'">

    <v-row>
      <v-col
        class="pa-0">

        <!-- on image bar -->
        <v-row class="carousel-top-element white--text">
          <v-col class="py-0 max-width-1200 mx-auto">
            <app-bar-menu
              component="SubMetering"
              logo="light"
              dark="dark">
            </app-bar-menu>
          </v-col>
        </v-row>

        <!-- hero -->
        <v-card flat dark>
          <v-img
            id="img-main"
            src="@/assets/img/em-submetering-01.jpg"
            class="grey lighten-2"
            cover
            :min-height="breakpoint ? '' : 750"
            :max-height="computedPageHeight"
            :style="'height:' + computedPageHeight + 'px'">
            <div class="overlay">

              <!-- TODO wrap on small display -->
              <v-row
                class="fill-height max-width-1200 mx-auto"
                align="center"
                justify="center">
                <v-col cols="12" class="max-width-600 mr-auto">
                  <v-row>
                    <v-col class="text-start">
                      <span class="product-brand">{{$t("energyManagement.service.subMetering.subtitle")}}</span><br>
                      <span class="product-name">{{ $t('energyManagement.service.subMetering.title') }}</span>
                    </v-col>
                  </v-row>
                  <v-row
                    v-for="(item,index) in pros"
                    :key="index">
                    <v-col class="text-start product-pro border-bottom-light">
                      {{ $t(item.short) }}
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <!-- ic img -->
              <v-row class="carousel-bottom-controls">
                <v-col class="pa-0 img-ic-box flip-x">
                </v-col>
              </v-row>

              <!-- landing scroll menu -->
              <v-row class="menu landing-scroll">
                <v-col class="max-width-1200 px-0 mx-auto">
                  <v-btn
                    id="back" name="back" title="back"
                    text dark
                    @click="loadPage('EnergyManagement')">
                      <v-icon>
                        mdi-chevron-double-left
                      </v-icon>
                  </v-btn>
                  <v-btn
                    v-for="(item,index) in sections"
                    :key="index"
                    text dark
                    @click="scrollTOSection(item.id)">
                      {{ $t(item.title) }}
                  </v-btn>
                </v-col>
              </v-row>

            </div>
          </v-img>

        </v-card>

        <v-row class="mx-1">
          <v-col id="about">
            <About></About>
          </v-col>
        </v-row>
        <v-row class="mx-1">
          <v-col id="technology">
            <Promo></Promo>
          </v-col>
        </v-row>
        <v-row class="mx-0 bg-grey-light">
          <v-col id="cost">
            <Cost></Cost>
          </v-col>
        </v-row>
        <v-row class="mx-1">
          <v-col id="cost">
            <ContactNow></ContactNow>
          </v-col>
        </v-row>
        <v-row class="mx-0 bg-ruby">
          <v-col id="contact">
            <Contact></Contact>
          </v-col>
        </v-row>

      </v-col>
    </v-row>
  </v-container>
</template>


<script>
  import AppBarMenu from '@/components/Common/AppBar.vue';
  import DataComponentBase from '@/commons/DataComponentBase';

  import About from '@/components/EnergyManagement/SubMetering/About.vue'
  import Promo from '@/components/EnergyManagement/SubMetering/Promo.vue'
  import Cost from '@/components/EnergyManagement/SubMetering/Cost.vue'
  import ContactNow from '@/components/EnergyManagement/SubMetering/ContactNow.vue'
  import Contact from '@/components/Common/Contact.vue'


  export default {
    name: 'SubMetering',

    metaInfo: {
      title: 'Almérősítés',
      titleTemplate: '%s - Rubin Informatika',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: 'Minden szakreferens igénybevételére kötelezett vállalkozás köteles villamos fogyasztásmérőt felszerelni. Ne késlekedjen és bízza a Rubinra!'
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: 'almérősítés, 16/2021. (XII. 8.) MEKH rendelet, /2020. (I. 16.) MEKH rendelet, mérőrendszer, Rubin ENERGIAMONITOR'
        }
      ],
      __dangerouslyDisableSanitizers: ['meta'],
    },

    extends: DataComponentBase,

    components: {
      AppBarMenu,
      About,
      Promo,
      Cost,
      ContactNow,
      Contact,
    },

    data: () => ({
      pros: [
        { title: "", short: "subMetering.pros.01.short", component: "",},
        { title: "", short: "subMetering.pros.02.short", component: "",},
        { title: "", short: "subMetering.pros.03.short", component: "",},
      ],
      sections: [
        { id: "about",          title: "common.about", },
        { id: "technology",     title: "subMetering.promo.title", },
        { id: "cost",           title: "common.cost", },
      ],
    }),

    mounted() {
    },

    computed: {
      breakpoint() {
        if (this.computedWidth < 961) {
          return true
        } else {
          return false
        }
      },
      computedCarouselHeight() {
      return this.styleProps.windowHeight;
    },
    },

    methods: {
      scrollTOSection(id) {
        var section = document.getElementById(id);
        section.scrollIntoView();
      }
    },
  }

</script>

<style src="../../Style.css">
</style>
